// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"fd90594e","899":"4087f085"}[chunkId] + ".chunk.css";
};